export default "__VITE_ASSET__CTj0Grxj__"